import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { reduceToArray } from '../../../../utils/reduce-to-array';
import { browsingDomainStore } from '../../store';
import { getEventById } from './get-event-by-id';
export const getAllEvents = () => {
    const eventIds = getFetchedDataPayload(browsingDomainStore.data.eventIdsForAllEvents);
    return eventIds ? reduceToArray(eventIds, getEventById) : undefined;
};
